import palette from '../palette';

export default {
  root: {},
  outlined: {
    backgroundColor: palette.common.white,
    padding: '0 2px',
  },
};
